var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMemory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "memory") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5, 0.5)",
    fill: "none",
    stroke: "currentColor",
    className: "nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 3,
    strokeLinecap: "round",
    d: "M32,10.2 C32,5.7,28.3,2,23.8,2c-3.6,0-6.6,2.3-7.7,5.5c-0.2,0-0.3,0-0.5,0C8.1,7.5,2,13.6,2,21.1c0,3.7,1.5,7,3.8,9.5C3.5,32,2,34.5,2,37.5 c0,2.8,1.4,5.2,3.5,6.7c-0.4,1.3-0.7,2.8-0.7,4.2c0,7.5,6.1,13.6,13.6,13.6S32,55.9,32,48.4V28",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 3,
    strokeLinecap: "round",
    d: "M32,10.2 C32,5.7,35.7,2,40.2,2c3.6,0,6.6,2.3,7.7,5.5c0.2,0,0.3,0,0.5,0c7.5,0,13.6,6.1,13.6,13.6c0,3.7-1.5,7-3.8,9.5 c2.3,1.4,3.8,4,3.8,6.9c0,2.8-1.4,5.2-3.5,6.7c0.4,1.3,0.7,2.8,0.7,4.2c0,7.5-6.1,13.6-13.6,13.6S32,55.9,32,48.4",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 3,
    strokeLinecap: "round",
    d: "M15.6,34.7 c-3.9,0-7.4-1.6-9.9-4.2",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 3,
    strokeLinecap: "round",
    d: "M48.4,34.7 c3.9,0,7.4-1.6,9.9-4.2",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 3,
    strokeLinecap: "round",
    d: "M32,10.2 c0,4.5-3.5,7.8-8,7.8",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 3,
    strokeLinecap: "round",
    d: "M32,10.2 c0,4.5,3.5,7.8,8,7.8",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 3,
    strokeLinecap: "round",
    d: "M21.1,42.4 c-3.2-1.1-5.4-4.2-5.4-7.7c0-2.4,1.1-4.6,2.7-6.1",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 3,
    strokeLinecap: "round",
    d: "M42.9,42.4 c3.2-1.1,5.4-4.2,5.4-7.7c0-2.4-1.1-4.6-2.7-6.1",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemory);
export default __webpack_public_path__ + "static/media/memory.aa5ed4c4eedb05623cb4d14b4df03f0f.svg";
export { ForwardRef as ReactComponent };